__turbopack_context__.v({
  "addSubPageInitial": "TerraceSubPageHeader-module-scss-module__T2JIwa__addSubPageInitial",
  "backIcon": "TerraceSubPageHeader-module-scss-module__T2JIwa__backIcon",
  "blocksBackgroundColor": "TerraceSubPageHeader-module-scss-module__T2JIwa__blocksBackgroundColor",
  "blocksFontColor": "TerraceSubPageHeader-module-scss-module__T2JIwa__blocksFontColor",
  "breadcrumbSelected": "TerraceSubPageHeader-module-scss-module__T2JIwa__breadcrumbSelected",
  "container": "TerraceSubPageHeader-module-scss-module__T2JIwa__container",
  "containerTwoRows": "TerraceSubPageHeader-module-scss-module__T2JIwa__containerTwoRows",
  "followButton": "TerraceSubPageHeader-module-scss-module__T2JIwa__followButton",
  "microsite": "TerraceSubPageHeader-module-scss-module__T2JIwa__microsite",
  "micrositeCanDrag": "TerraceSubPageHeader-module-scss-module__T2JIwa__micrositeCanDrag",
  "micrositeContainer": "TerraceSubPageHeader-module-scss-module__T2JIwa__micrositeContainer",
  "restoreButton": "TerraceSubPageHeader-module-scss-module__T2JIwa__restoreButton",
  "secondaryNavBackgroundColor": "TerraceSubPageHeader-module-scss-module__T2JIwa__secondaryNavBackgroundColor",
  "themeBackgroundColor": "TerraceSubPageHeader-module-scss-module__T2JIwa__themeBackgroundColor",
  "themeFontColor": "TerraceSubPageHeader-module-scss-module__T2JIwa__themeFontColor",
  "themeFontFamily": "TerraceSubPageHeader-module-scss-module__T2JIwa__themeFontFamily",
  "title": "TerraceSubPageHeader-module-scss-module__T2JIwa__title",
  "titleAndSubSections": "TerraceSubPageHeader-module-scss-module__T2JIwa__titleAndSubSections",
  "titleHomePage": "TerraceSubPageHeader-module-scss-module__T2JIwa__titleHomePage",
});
